<template>
  <div>
    <b-card title="Reports viewed">
      <b-card-text>
        This table shows how many products viewed in recent months. The higher the percentage viewed, the better you can
        evidence whole of market compliance.
        <br>
        On <router-link to="/products/current">
          Current Products
        </router-link> the products which have been viewed are
        indicated by a "tick" present.
      </b-card-text>
      <loading-container v-if="userHistory.loading" />
      <error-display v-else-if="userHistory.error" />
      <div v-else>
        <b-table
          responsive="sm"
          hover
          :items="userHistory.data"
          :fields="userHistory.fields"
          :sort-by.sync="userHistory.sortBy"
          :sort-desc.sync="userHistory.sortDesc"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText, BTable,
} from 'bootstrap-vue'
import ErrorDisplay from '@/views/components/ErrorDisplay.vue'
import LoadingContainer from '@/views/components/LoadingContainer.vue'

export default {
  components: {
    BTable,
    LoadingContainer,
    ErrorDisplay,
    BCard,
    BCardText,
  },
  data() {
    return {
      userHistory: {
        data: [],
        fields: [
          {
            key: 'period',
            label: 'Period',
            sortable: false,
          },
          {
            key: 'numberPublished',
            label: 'Number published',
            sortable: true,
            class: 'text-center',
          },
          {
            key: 'numberViewed',
            label: 'Number viewed',
            sortable: true,
            class: 'text-center',
          },
          {
            key: 'percentageViewed',
            label: 'Percentage viewed',
            sortable: true,
            class: 'text-center',
          },
        ],
        sortBy: null,
        sortDesc: false,
        loading: false,
        error: false,
      },
    }
  },
  mounted() {
    this.loadUserHistory()
  },
  methods: {
    loadUserHistory() {
      this.userHistory.loading = true
      this.$http
        .get('research.cfc?method=getUserHistory&numMonths=6')
        .then(response => {
          this.userHistory.data = response.data.content
        })
        .catch(error => {
          this.userHistory.error = error
        })
        .finally(() => {
          this.userHistory.loading = false
        })
    },
  },
}
</script>
